import './App.scss';
import menuConfig from './menuConfig.json'; // Import JSON file
import { Link } from 'react-router-dom';
import { useState } from 'react';
import { isRestrictedRoleOnly } from './keycloakConfig';

// Recursive component to handle nested menus
const MenuItem = ({ menu }) => {
  const [activeMenu, setActiveMenu] = useState('');

  const handleMenuHover = (menuName) => {
    setActiveMenu(menuName);
  };

  const handleMouseLeave = () => {
    setActiveMenu('');
  };

  return (
    <li
      className={`nav-item ${activeMenu === menu.name ? 'active' : ''}`}
      onMouseEnter={() => handleMenuHover(menu.name)}
      onMouseLeave={handleMouseLeave}
    >
      {menu.subMenu && menu.subMenu.length > 0 ? (
        // If there are submenus, prevent navigation
        <div className="nav-link text-center" style={{ cursor: 'pointer' }}>
          <p className={`sidebar-icon ${menu.iconClass}`}></p>
          <p className='menu-name'>{menu.name}</p>
        </div>
      ) : (
        // If no submenu, allow navigation
        <Link className='nav-link text-center' to={menu.path}>
          <p className={`sidebar-icon ${menu.iconClass}`}></p>
          <p className='menu-name'>{menu.name}</p>
        </Link>
      )}
      {menu.subMenu && menu.subMenu.length > 0 && activeMenu === menu.name && (
        <ul className="sub-menu-box">
          {menu.subMenu.map((subMenu) => (
            <li key={subMenu.id || subMenu.name} className="sub-menu-item">
              <Link className="sub-menu-link" to={subMenu.path}>
                {subMenu.name}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};

// Menu entries (by id) that exist only for the OPERATOR/QA nav and must stay hidden from everyone else.
const RESTRICTED_ROLE_ONLY_MENU_IDS = ['devices-hubs', 'devices-operator'];
// Menu entries (by id) OPERATOR-only and QA-only users are allowed to see.
const RESTRICTED_ROLE_VISIBLE_MENU_IDS = ['ota-updates', 'devices-operator', 'devices-hubs'];

function Sidebar() {
  const visibleMenus = isRestrictedRoleOnly()
    ? menuConfig.filter((menu) => RESTRICTED_ROLE_VISIBLE_MENU_IDS.includes(menu.id))
    : menuConfig.filter((menu) => !RESTRICTED_ROLE_ONLY_MENU_IDS.includes(menu.id));

  return (
    <div className="sidebar-wrapper">
      <ul className='nav sidebar-list'>
        {visibleMenus.map((menu) => (
          // Use a unique key for top-level menu items
          <MenuItem key={menu.id || menu.name} menu={menu} />
        ))}
      </ul>
    </div>
  );
}

export default Sidebar;
